import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams, AlertController } from 'ionic-angular';
import { Globals } from "../../../globals";
import { ReservationsServices } from "../services";
import { DatePipe } from '@angular/common';
import { ReservationCreatePage } from "../reservation-create/reservation-create";
import { PrintServices } from '../../services/printServices';
import { ConfigurationServices } from '../../configuration/services';
import { ReservationLoaderPage } from '../../reservation/reservation-loader/reservation-loader';
import { TranslateService } from '@ngx-translate/core';
import { ReservationManualCreatePage } from '../reservation-manual-create/reservation-manual-create';
import { AddonsTriggerVersionProPage } from '../../addons/addons-trigger-version-pro/addons-trigger-version-pro';

/**
 * Generated class for the ReservationDayPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-reservation-day',
  templateUrl: 'reservation-day.html',
})
export class ReservationDayPage {
  event: any;
  date: any;
  valueChanges: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    public reservationsServices: ReservationsServices,
    private datePipe: DatePipe,
    public printServices: PrintServices,
    public configurationServices: ConfigurationServices,
    public http: HttpClient,
    public alertCtrl: AlertController,
    public translate: TranslateService) {

    this.globals.GAtrackView('Reservations', 'Reservations - Day - View', this.globals.restaurant.email, 'View', 'View reservations day ', 'Reservations', '');

  }

  ionViewWillEnter() {
    let loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: ''
    });
    loadingPopup.present();
    this.reservationsServices.getListReservations(this.globals.restaurant_uid);

    this.event = this.navParams.get('event');
    this.date = this.datePipe.transform(this.event.start, "yyyy-MM-dd");

    this.reservationsServices.getListReservationsComplete(this.globals.restaurant_uid, this.date);

    this.reservationsServices.reservationCol = this.reservationsServices.afs.collection('reservations', ref => ref.where('UID_RESTAURANT', '==', this.globals.restaurant_uid).where('date', '==', this.date).orderBy('hour', 'asc')); //Recuperamos el plato para tener el plato simpre actulizado.
    this.valueChanges = this.reservationsServices.reservationCol.valueChanges().subscribe(value => {


      this.reservationsServices.reservations_tmp = value;
    });


    loadingPopup.dismiss();
  }

  ionViewDidLeave() {
    this.reservationsServices.stripe_1 = 0;
    this.reservationsServices.stripe_1_doc = null;
    this.reservationsServices.stripe_2 = 0;
    this.reservationsServices.stripe_2_doc = null;
    this.reservationsServices.stripe_3 = 0;
    this.reservationsServices.stripe_3_doc = null;
  }


  openReservation(reservation) {
    this.navCtrl.push(ReservationCreatePage, {
      reservation: reservation,
      update_state: true,
      event: this.event
    });
  }
  //crear reserva manual -> apunta a la pagina manual
  createReservation() {
    if (this.globals.checkLimitsByLicense('reservations', 'calendar')) {
      this.navCtrl.push(ReservationManualCreatePage, {
        update_state: false,
        date: this.datePipe.transform(this.event.start, "yyyy-MM-dd"),
        event: this.event
      });
    } else {
      this.navCtrl.push(AddonsTriggerVersionProPage);
    }
  }

  insert(stripe) {

    let alert = this.alertCtrl.create({

      title: this.translate.instant('reservas-day-marcar-franja-completa'),
      message: this.translate.instant('reservas-day-seguro-marcar-franja-completa'),
      buttons: [
        {
          text: this.translate.instant('general-no'),
          role: 'cancel',
          handler: () => {
          }
        },
        {
          text: this.translate.instant('general-si'),
          handler: () => {
            this.reservationsServices.afs.collection('reservation_complete').add({
              'UID_RESTAURANT': this.globals.restaurant_uid,
              'date': this.date,
              'stripe': stripe,
            }).then(doc => {
              this.globals.side_menu_active = 'reservation';
              this.navCtrl.setRoot(ReservationLoaderPage);
            });
          }
        }
      ]
    });
    alert.present();
  }

  async openPrint() {

    let loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: ''
    });
    loadingPopup.present();


    //Format object menu for POST send
    var reservations_send = this.reservationsServices.reservations_tmp;
    /*for (let reservation of this.globals.objectToArray(reservations_send)) {
      reservation.date = this.globals.returnDate(reservation.date + " " + reservation.hour);
      reservation.hour = this.globals.returnTime(reservation.date + " " + reservation.hour);
    }*/
    var date = this.datePipe.transform(this.date, "dd/MM/yyyy");
    var uid = this.globals.restaurant_uid.substring(0, 3);

    this.globals.GAtrackView('Reservations', 'Reservations - Sheet - Print', this.globals.restaurant.email, 'View', 'Print Sheet', 'Reservations', this.date);


    this.http.post(this.globals.api_path + 'reservation/print_basic',
      {
        reservations: reservations_send,
        date: date,
        uid: uid,
      }, {})
      .subscribe(res => {
        if (this.globals.so_mobile) {
          window.location.assign(String(res['file']));
        } else {
          window.open(String(res['file']), '_blank');
        }
        loadingPopup.dismiss();
      }, error => {
        loadingPopup.dismiss();
      });
  }


  openPrintFull() {

    let loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: ''
    });
    loadingPopup.present();


    //Format object menu for POST send
    var reservations_send = this.reservationsServices.reservations_tmp;
    /*for (let reservation of this.globals.objectToArray(reservations_send)) {
      reservation.date = this.globals.returnDate(reservation.date + " " + reservation.hour);
      reservation.hour = this.globals.returnTime(reservation.date + " " + reservation.hour);
    }*/
    var date = this.globals.returnDate(this.date);
    var uid = this.globals.restaurant_uid.substring(0, 3);

    this.globals.GAtrackView('Reservations', 'Reservations - Full - Print', this.globals.restaurant.email, 'View', 'Print Full', 'Reservations', this.date);

    this.http.post(this.globals.api_path + 'reservation/print_full',
      {
        reservations: reservations_send,
        date: date,
        uid: uid,
      }, {})
      .subscribe(res => {
        if (this.globals.so_mobile) {
          window.location.assign(String(res['file']));
        } else {
          window.open(String(res['file']), '_blank');
        }
        loadingPopup.dismiss();
      }, error => {
        loadingPopup.dismiss();
      });
  }


  delete(event, stripe) {
    //
    let alert = this.alertCtrl.create({

      title: this.translate.instant('reservar-day-marcar-franja-libre'),
      message: this.translate.instant('reservas-day-seguro-marcar-franja-libre'),
      buttons: [
        {
          text: this.translate.instant('general-no'),
          role: 'cancel',
          handler: () => {
          }
        },
        {
          text: this.translate.instant('general-si'),
          handler: () => {
            if (stripe == 1) {
              this.reservationsServices.stripe_1 = 0;
            } else if (stripe == 2) {
              this.reservationsServices.stripe_2 = 0;
            } else if (stripe == 3) {
              this.reservationsServices.stripe_3 = 0;
            }
            this.reservationsServices.deleteStripeComplete(event.UID);
            this.globals.side_menu_active = 'reservation';
            this.navCtrl.setRoot(ReservationLoaderPage);
          }
        }
      ]
    });
    alert.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/reservation/reservation-day/reservation-day.ts